import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import React, { useState } from "react";
import Translator from "Languages/Utility/Translator";
import Grid from "@material-ui/core/Grid";
import { read } from "Helpers/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import * as Icons from "react-bootstrap-icons";
import { managePartsCount } from "Stores/actions";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { managePartCountColumn } from "Constants/TableColumns";
import cellEditFactory from "react-bootstrap-table2-editor";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import showNotify from "Helpers/Notify";

export default function CountManagerDialog({ onChange }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { constructionResult, constructionSender } = useSelector((state) => ({
    constructionResult: state.construction.constructionResult,
    constructionSender: state.construction.constructionSender,
  }));
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [raw, setRaw] = useState(null);
  const [data, setData] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [changed, setChanged] = useState(false);

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    try {
      setData(null);
      setSelectedProfile(null);
      setChanged(false);
      setLoading(true);
      const response = await dispatch(
        managePartsCount({
          ...constructionSender,
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          TabPage: constructionResult.pageIndex,
        }),
      );
      const rawData = [];
      response.headerOptimalProfileInBranches.map((item) => {
        item.inDetailForCalcOptimals.map((i) => {
          rawData.push({
            id: i.PieceIDRow,
            count: i.CountPiece,
          });
        });
      });
      setData(response);
      setRaw(rawData);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onExit = () => {
    setOpenDialog(false);
    setLoading(false);
  };

  const onClickProfile = (item) => {
    setSelectedProfile(item);
  };

  const onDismiss = () => {
    setSelectedProfile(null);
  };

  const onTableChange = () => {
    return;
  };

  const updateCountInState = (row, newCount) => {
    const profileId = selectedProfile?.Id;
    if (!profileId) return;

    setSelectedProfile((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        inDetailForCalcOptimals: prev.inDetailForCalcOptimals?.map((item) =>
          item.PieceIDRow === row.PieceIDRow
            ? { ...item, CountPiece: newCount }
            : item,
        ),
      };
    });

    setData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        headerOptimalProfileInBranches:
          prev.headerOptimalProfileInBranches?.map((profile) =>
            profile.Id === profileId
              ? {
                  ...profile,
                  inDetailForCalcOptimals: profile.inDetailForCalcOptimals?.map(
                    (item) =>
                      item.PieceIDRow === row.PieceIDRow
                        ? { ...item, CountPiece: newCount }
                        : item,
                  ),
                }
              : profile,
          ),
      };
    });
  };

  const BeforeSaveCell = async (oldValue, newValue, row, column, done) => {
    const nv = +convertToEnglishNumber(newValue);
    const _nvtest = /^\d+$/.test(nv);
    let oriCount = 0;
    if (!raw) {
      done(false);
      return;
    } else {
      oriCount = raw.find((i) => i.id === row.PieceIDRow).count;
    }
    const ov = +convertToEnglishNumber(oriCount);
    if (nv === "" || nv === null || nv === undefined) {
      done(false);
      return;
    } else if (!_nvtest || nv < 0) {
      showNotify({
        text: t("ValueNotValid"),
        customClass: "error",
      });
      done(false);
      return;
    } else if (nv > ov) {
      showNotify({
        text: t("newValueNotBiggerAllowed"),
        customClass: "error",
      });
      done(false);
      return;
    } else if (nv <= ov) {
      updateCountInState(row, nv);
      showNotify({
        text: t("newValuesaved"),
        customClass: "success",
      });
      setChanged(true);
      done(true);
      return;
    }
  };

  const onPreviewClick = () => {
    onChange(data);
    handleDialog();
  };

  return (
    <>
      {constructionResult?.isBeforeOptimal &&
        (constructionResult.pageIndex === 170 ||
          constructionResult.pageIndex === 190) && (
          <>
            <MuiButton
              color="primary"
              className="my-2"
              title={<Translator id={"managePartsCount"} />}
              onClick={handleDialog}
            />
            {/* <Divider
              orientation="vertical"
              flexItem
              className="mx-1 divider-factor"
            /> */}
          </>
        )}

      <Dialog
        dir={direction}
        open={openDialog}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        onClose={handleDialog}
        fullWidth
        maxWidth="sm"
      >
        <BackDropLoading loading={loading} />
        {data ? (
          <>
            <div className="dialogHeader">
              <p>{`${t("managePartsCount")} - ${t("projectName")}: ${data.NameProjects}`}</p>
            </div>
            <DialogContent>
              {selectedProfile ? (
                <div>
                  <div className="mb-3 pb-3 border-bottom d-flex flex-row align-items-center g-2">
                    <MuiIconButton
                      className="primary-button"
                      title={t("backToList")}
                      icon={<Icons.CaretRightFill size={19} />}
                      onClick={onDismiss}
                    />
                    <p>{selectedProfile.Name}</p>
                  </div>
                  <RemoteTable
                    className="mt-2"
                    keyField="Id"
                    rowHeight="50px"
                    loading={loading}
                    data={selectedProfile.inDetailForCalcOptimals}
                    columns={managePartCountColumn}
                    onTableChange={onTableChange}
                    cellEdit={cellEditFactory({
                      mode: "click",
                      blurToSave: true,
                      autoSelectText: true,
                      beforeSaveCell: (oldValue, newValue, row, column, done) =>
                        BeforeSaveCell(oldValue, newValue, row, column, done),
                    })}
                  />
                </div>
              ) : (
                <>
                  <p className="mb-3 pb-3 border-bottom">
                    {t("selectOneProfile")}
                  </p>
                  {data.headerOptimalProfileInBranches?.length > 0 && (
                    <div>
                      {data.headerOptimalProfileInBranches.map(
                        (item, index) => (
                          <MuiButton
                            key={index}
                            color="primary"
                            className="mb-2 w-100"
                            title={item.Name}
                            onClick={() => onClickProfile(item)}
                          />
                        ),
                      )}
                    </div>
                  )}
                </>
              )}
            </DialogContent>
          </>
        ) : (
          <Grid container>
            <Grid item xs={12} className="p-5">
              <p className="w-100 text-center p-5">{t("pleaseWait")}</p>
            </Grid>
          </Grid>
        )}
        <DialogActions>
          {changed && (
            <MuiButton
              color="primary"
              title={<Translator id="preview" />}
              onClick={onPreviewClick}
            />
          )}
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
